<template>
  <div
    class="customers-task-overview-component"
    v-bind:class="{ loaded: initialized }"
  >
    <div class="panel-body">
      <laravel-pagination
        v-if="displayPagination"
        v-bind:data="currentRequestData"
        v-on:pagination-change-page="loadTasksPage"
        style="
          margin: 0;
          vertical-align: middle;
          margin-top: -4px;
          margin-right: 1.5rem;
        "
      ></laravel-pagination>

      Per pagina
      <a-select
        v-bind:default-value="perPage"
        v-on:change="handlePerPageChange"
      >
        <a-select-option v-bind:value="15"> 15 </a-select-option>
        <a-select-option v-bind:value="25"> 25 </a-select-option>
        <a-select-option v-bind:value="50"> 50 </a-select-option>
        <a-select-option v-bind:value="100"> 100 </a-select-option>
      </a-select>

      <a-button-group>
        <a-button
          v-bind:type="intervalValue == '365' ? 'primary' : undefined"
          v-on:click="manualInterval = '365'"
        >
          Openstaande taken
        </a-button>
        <a-button
          v-bind:type="intervalValue == '-30' ? 'primary' : undefined"
          v-on:click="manualInterval = '-30'"
        >
          Afgeronde taken
        </a-button>
      </a-button-group>

      <div class="pull-right">
        <a-popconfirm
          placement="topRight"
          title="Weet je zeker dat je deze taken wil afronden?"
          ok-text="Afronden"
          cancel-text="Annuleren"
          v-bind:disabled="!hasSelection"
          v-on:confirm="onCompleteAllClick"
        >
          <a-button
            type="primary"
            v-bind:disabled="!hasSelection"
            v-if="displayActiveTasks"
          >
            <check-icon style="margin-right: 0.3em"></check-icon>
            {{
              selectedTasks.length > 0
                ? selectedTasks.length + " afronden"
                : "Afronden"
            }}
          </a-button>
        </a-popconfirm>
      </div>
    </div>
    <lazy-component
      v-on:intersected="onInit"
      v-bind:is-intersected="forceIntersect"
    >
      <template v-if="initialized">
        <div v-if="hasTasks">
          <table class="table">
            <thead>
              <tr>
                <th class="compact half-padding">
                  <a-checkbox
                    ref="globalCheckbox"
                    v-bind:checked="allSelected"
                    v-bind:indeterminate="indeterminate"
                    v-on:change="onSelectAllChanged"
                  ></a-checkbox>
                </th>
                <th colspan="1"></th>
                <th class="compact">Labels</th>
                <th>Gekoppeld aan</th>
                <th>Klant</th>
                <th>Datum</th>
                <th class="compact">Gemaakt door</th>
                <th v-if="!displayActiveTasks" class="compact">
                  Afgerond door
                </th>
                <th v-if="!displayActiveTasks" class="compact">Afgerond op</th>
                <th v-if="displayActiveTasks" class="compact">
                  Toegewezen aan
                </th>
                <th class="compact">Publiek</th>
                <th class="compact"></th>
              </tr>
            </thead>
            <tbody v-bind:class="{ loading: loading }">
              <tr v-if="!initialized">
                <td v-bind:colspan="displayActiveTasks ? 8 : 9">Laden ...</td>
              </tr>
              <TaskRowComponent
                v-for="task in tasks"
                v-bind:key="task.id"
                v-bind:task="task"
                v-bind:interval="manualInterval"
                v-bind:user-id="userId"
                v-bind:displayProductLabels="true"
                v-on:onSelectionChanged="onSelectionChanged"
                v-on:onCompleted="onCompleted"
                v-on:onUnmatched="onUnmatched"
                @onDateChanged="onDateChanged"
                @onDeleted="onDeleted"
              >
              </TaskRowComponent>
            </tbody>
          </table>
          <div class="panel-body" style="padding-top: 0">
            <laravel-pagination
              v-if="displayPagination"
              v-bind:data="currentRequestData"
              v-on:pagination-change-page="loadTasksPage"
              style="margin: 0"
            ></laravel-pagination>
          </div>
        </div>
        <div v-else class="widget-body" style="margin: 1.5rem">
          <p>
            Er zijn geen
            {{ displayActiveTasks ? "onafgehandelde" : "afgeronde" }} taken.
          </p>
        </div>
      </template>
      <div v-else style="padding: 8px">
        <Skeleton
          class="skeleton"
          v-bind:loading="true"
          style="width: 100%; height: 30px; display: block; margin-bottom: 10px"
        ></Skeleton>
        <Skeleton
          class="skeleton"
          v-bind:loading="true"
          style="
            width: 20px;
            height: 20px;
            margin-right: 10px;
            display: inline-block;
          "
        ></Skeleton>
        <Skeleton
          class="skeleton"
          v-bind:loading="true"
          style="
            width: calc(36% - 40px);
            height: 20px;
            margin-right: 10px;
            display: inline-block;
          "
        ></Skeleton>
        <Skeleton
          class="skeleton"
          v-bind:loading="true"
          style="
            width: calc(10% - 10px);
            height: 20px;
            margin-right: 10px;
            display: inline-block;
          "
        ></Skeleton>
        <Skeleton
          class="skeleton"
          v-bind:loading="true"
          style="
            width: calc(10% - 10px);
            height: 20px;
            margin-right: 10px;
            display: inline-block;
          "
        ></Skeleton>
        <Skeleton
          class="skeleton"
          v-bind:loading="true"
          style="
            width: calc(10% - 10px);
            height: 20px;
            margin-right: 10px;
            display: inline-block;
          "
        ></Skeleton>
        <Skeleton
          class="skeleton"
          v-bind:loading="true"
          style="
            width: calc(10% - 10px);
            height: 20px;
            margin-right: 10px;
            display: inline-block;
          "
        ></Skeleton>
        <Skeleton
          class="skeleton"
          v-bind:loading="true"
          style="
            width: calc(10% - 10px);
            height: 20px;
            margin-right: 10px;
            display: inline-block;
          "
        ></Skeleton>
        <Skeleton
          class="skeleton"
          v-bind:loading="true"
          style="width: 10%; height: 20px; display: inline-block"
        ></Skeleton>
      </div>
    </lazy-component>

    <ShowTaskListDrawer ref="taskListDrawer"></ShowTaskListDrawer>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import taskApi from "~/api/task";
import store from "../../../store";
import taskModule from "../store";
import TaskRowComponent from "./TaskRowComponent";
import { Skeleton } from "vue-loading-skeleton";
import ShowTaskListDrawer from "~/modules/task_list/components/ShowTaskListDrawer.vue";

export default {
  name: "CustomersTaskOverviewComponent",
  props: {
    customerIds: {
      type: Array,
      default: null,
    },
    userId: {
      type: Number,
      required: true,
    },
    interval: {
      type: Number,
      default: 1,
    },
    page: {
      type: Number,
      default: 1,
    },
  },
  components: {
    ShowTaskListDrawer,
    TaskRowComponent,
    Skeleton,
  },
  data() {
    return {
      currentPage: null,
      tasks: [],
      currentRequestData: {},
      allSelected: false,
      loading: true,
      initialized: false,
      manualInterval: null,
    };
  },
  created() {
    if (!store.hasModule("task")) {
      store.registerModule("task", taskModule);
    }
  },
  computed: {
    ...mapGetters(["forceIntersect"]),
    ...mapGetters("task", ["perPage", "selectedTasks"]),
    intervalValue() {
      if (this.manualInterval == null) {
        return this.interval;
      }

      return this.manualInterval;
    },
    indeterminate() {
      return (
        this.allSelected === false &&
        this.currentSelectionDiff !== this.tasks.length &&
        this.currentSelectionDiff > 0
      );
    },
    currentSelectionDiff() {
      return this.tasks.filter(
        (i) => this.selectedTasks.findIndex((x) => x.id === i.id) < 0
      ).length;
    },
    displayPagination() {
      return typeof this.currentRequestData.meta !== "undefined";
    },
    hasSelection() {
      return this.selectedTasks.length > 0;
    },
    selectedUnlinkableTasks() {
      return this.selectedTasks.filter(
        (task) => typeof task.customer !== "undefined" && task.customer !== null
      );
    },
    hasUnlinkableSelection() {
      return this.selectedUnlinkableTasks.length > 0;
    },
    displayActiveTasks() {
      return this.intervalValue >= 0;
    },
    hasTasks() {
      return (this.initialized && this.tasks.length > 0) || !this.initialized;
    },
  },

  methods: {
    ...mapActions("task", ["setPerPage"]),
    onInit() {
      this.loadTasksPage(this.page);
    },
    onSelectionChanged(task, selected, shiftKey) {
      if (selected === true) {
        this.selectTask(task);
      } else {
        this.deselectTask(task);
      }
    },
    onSelectAllChanged() {
      this.allSelected = !this.allSelected;

      for (let i in this.tasks) {
        let task = this.tasks[i];

        if (
          this.allSelected === true &&
          this.selectedTasks.findIndex((x) => x.id === task.id) < 0
        ) {
          this.selectTask(task);
        } else if (this.allSelected === false) {
          this.deselectTask(task);
        }
      }
    },
    selectTask(task) {
      store.dispatch("task/selectTask", task);
      if (this.currentSelectionDiff === 0) {
        this.allSelected = true;
      }
    },
    deselectTask(task) {
      this.allSelected = false;
      store.dispatch("task/deselectTask", task);
    },
    deselectAllTasks() {
      this.allSelected = false;
      store.dispatch("task/deselectAllTasks");
    },
    loadTasksPage(page = 1, forceReload = false) {
      if (page === this.currentPage && forceReload !== true) {
        return;
      }
      this.loading = true;

      if (this.displayActiveTasks) {
        taskApi
          .getActiveByCustomerIds(
            this.customerIds,
            this.intervalValue,
            page,
            this.perPage
          )
          .then((tasks) => {
            this.allSelected = false;
            this.tasks = tasks.data;
            this.currentRequestData = tasks;
            this.loading = false;
            this.initialized = true;
            this.currentPage = page;
          })
          .catch(() => {
            this.$notification["error"]({
              message: "Er ging iets mis",
              description: "Het is niet gelukt om taken te laden",
            });
          });
      } else {
        taskApi
          .getCompletedByCustomerIds(
            this.customerIds,
            this.intervalValue,
            page,
            this.perPage
          )
          .then((tasks) => {
            this.allSelected = false;
            this.tasks = tasks.data;
            this.currentRequestData = tasks;
            this.loading = false;
            this.initialized = true;
            this.currentPage = page;
          })
          .catch(() => {
            this.$notification["error"]({
              message: "Er ging iets mis",
              description: "Het is niet gelukt om taken te laden",
            });
          });
      }
    },
    onUnmatchAllClick() {
      this.loading = true;

      taskApi
        .unmatchTasks(this._.map(this.selectedTasks, "id"))
        .then(() => {
          this.loading = false;
          // trigger reload
          for (let i in this.selectedTasks) {
            this.selectedTasks[i].customer = null;
          }
        })
        .catch(() => {
          this.$notification["error"]({
            message: "Er ging iets mis",
            description: "Kon de geselecteerde taken niet ontkoppelen",
          });
        });
    },
    onCompleteAllClick() {
      this.loading = true;
      taskApi
        .completeTasks(
          this._.map(this.selectedTasks, "id"),
          this.userId,
          this.intervalValue
        )
        .then((response) => {
          // trigger reload
          this.loadTasksPage(this.page, true);
          this.deselectAllTasks();
        })
        .catch((error) => {
          this.$notification["error"]({
            message: "Er ging iets mis",
            description: "Kon de geselecteerde taken niet verwerken",
          });
        });
    },
    processBadges(badge, count) {
      let $badge = $(badge);
      if (count === 0) {
        $badge.addClass("hidden");
      } else {
        $badge.removeClass("hidden").text(count);
      }
    },
    onCompleted() {
      this.loadTasksPage(this.currentPage, true);
    },
    onUnmatched() {
      // this.loadTasksPage(this.page);
    },
    onDateChanged() {
      this.loadTasksPage(this.currentPage, true);
    },
    onDeleted() {
      this.loadTasksPage(this.currentPage, true);
    },
    handlePerPageChange(perPage) {
      this.setPerPage(perPage);
      this.loadTasksPage(this.page, true);
    },
  },
  watch: {
    manualInterval: function (oldInterval, newInterval) {
      this.loadTasksPage(this.page, true);
    },
  },
  mounted() {},
};
</script>

<style scoped>
tr th.half-padding {
  padding: 4px;
}

tbody.loading {
  opacity: 0.5;
}

table th.compact,
table td.compact {
  white-space: nowrap;
  width: 1px !important;
}
</style>
